export const ACTION_PREFIX = 'HOTJAR';

export const Actions = {
  TRIGGER: `${ACTION_PREFIX}/TRIGGER`,
  TAG_RECORDING: `${ACTION_PREFIX}/TAG_RECORDING`,
};

export const SURVEYS = {
  ADVERTISER_LANDLORD: 'nps-advertiser-landlord',
  ADVERTISER_STUDENT: 'nps-advertiser-student',
  TENANT: 'nps-tenant',
};
